import { useModal } from '@ebay/nice-modal-react';
import './ApiModalResponseEdition.css';
import { useBotStateContext } from '/src/features/editor/contexts/BotContext';
import Dropdown from '../../../../../../components/UI/DropDown/DropDown';
import TextInput from '/src/components/UI/TextField/TextInput';
import Button from '/src/components/UI/Button/Button';
import DataVariables from '/src/data/dropdown/variables';
import { useForm } from 'react-hook-form';
import VariableDropdown from '../../../Variables/VariablesDropdown/VariablesDropdown';
import { useState } from 'react';

// Popup use to create or modificate a variable name / type
function ApiModalResponseEdition( { onClose } ) {
    const { variables } = useBotStateContext();
    const modal = useModal();
    const { register, getValues, formState, setValue } = useForm({ mode: "onChange" });

    const onClick = () => { 
        // ! important to resolve the value, api's call are declared in another component
        modal.resolve(getValues())
        return onClose();
    }

    const [typeResponse, setTypeResponse] = useState(0);
    const [dropdownVariableValidate, setdropdownVariableValidate] = useState(null);
    const choices = [
        {
            value : 0,
            text : 'Existing Variable'
        },
        {
            value : 1,
            text : 'Create new variable'
        }
    ]

    const isDisableButton = typeResponse == 1 ? !formState.isValid : !formState.isValid || !dropdownVariableValidate

    return (
        <form className='api_responses_modal'>
            <label className='title'>Create a Response</label>
            <div className='area-edit'>
            <div className='grid-row'>
                    <label className="dropdown_title">Parameter name : </label>
                    <TextInput style={{ height : 20, marginTop : 18}} {...register('key', { required : true})} className="input full-width" placeholder="Key" autoComplete="off"/>
                </div>  
                <div className='grid-row'>
                    <label className="dropdown_title">Type of Variable : </label>
                    <Dropdown {...register('variable_type')} setValue={(name, value) => {
                        setValue(name, value);
                        setTypeResponse(value);
                    }} choices={choices} width="22vw"/>
                </div>  

                { typeResponse == 1 ? 
                <>
                    <div className='grid-row'>
                        <label className="dropdown_title">Variable : </label>
                        <TextInput 
                        style={{ height : 20, marginTop : 18}} autoComplete="off"
                        {...register('variable_name', { required : true, setValueAs : (v) => v.toLowerCase(), validate : (v) => variables.filter(variable => variable.name == v).length == 0})} 
                        className={`variable_input ${Object.keys(formState.errors).length && formState.errors.variable_name && formState.errors.variable_name.type == 'validate' ? ' error' : ''}`} placeholder="Variable name"/>
                    </div>
                    <div className='grid-row'>
                        <label className="dropdown_title">Type : </label>
                        <Dropdown {...register('type')} setValue={setValue} choices={DataVariables} width="22vw"/>
                    </div>  
                </>
                : null
                }

                { typeResponse == 0 ? 

                <div className='grid-row'>
                    <label className="dropdown_title">Variable : </label>
                    <VariableDropdown register={register('variable')} setValue={(name, value) => setValue(name, value) == null ? setdropdownVariableValidate(value) : null} choices={DataVariables} width="22vw" createVariableDisable={true} resetVariableDisable={true}/>
                </div> 
                : null
                }
            </div>
            <Button label="Confirm" onClick={onClick} disabled={isDisableButton}/>
        </form>
    )
}

export default ApiModalResponseEdition;